import { render, staticRenderFns } from "./ReturnRequests.vue?vue&type=template&id=a7ae57f2&scoped=true"
import script from "./ReturnRequests.vue?vue&type=script&lang=js"
export * from "./ReturnRequests.vue?vue&type=script&lang=js"
import style0 from "./ReturnRequests.vue?vue&type=style&index=0&id=a7ae57f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ae57f2",
  null
  
)

export default component.exports